export function CartIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={16}
            height={14}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 16 14"
        >
            <path
                d="M0 .752c0-.204.07-.38.212-.53A.698.698 0 01.726 0h2.31c.402 0 .685.081.85.244.168.162.273.406.314.731l.103.676h10.861c.265 0 .47.072.617.216.146.139.219.32.219.543a.957.957 0 01-.014.153 1.749 1.749 0 01-.02.153l-.494 3.365c-.077.552-.265.984-.561 1.295-.293.311-.71.467-1.255.467H5.173l.11.71a.66.66 0 00.165.39.47.47 0 00.349.14h7.784a.68.68 0 01.473.188.63.63 0 01.205.487.647.647 0 01-.205.502.68.68 0 01-.473.188H5.62c-.544 0-.962-.156-1.254-.467-.292-.311-.48-.738-.562-1.281L2.768 1.504H.726a.698.698 0 01-.514-.222A.741.741 0 010 .752zm4.934 11.98c0-.232.057-.445.17-.64a1.29 1.29 0 01.453-.453 1.21 1.21 0 01.63-.167c.343 0 .636.123.878.369.246.246.37.543.37.891 0 .358-.124.657-.37.899-.242.246-.535.369-.877.369-.233 0-.444-.056-.63-.167a1.272 1.272 0 01-.453-.46 1.221 1.221 0 01-.171-.64zm6.29 0c0-.232.055-.445.164-.64a1.233 1.233 0 011.083-.62c.347 0 .642.123.884.369s.363.543.363.891c0 .358-.12.657-.363.899-.242.246-.537.369-.884.369-.342 0-.637-.123-.884-.37a1.218 1.218 0 01-.363-.898z"
                fill="#fff"
                className={fillClassName}
            />
        </svg>
    );
}



export function CheckedIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={11}
            height={11}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 11 11"
        >
            <path
                d="M1 6l3.5 4L10 1"
                stroke="#827252"
                strokeWidth={2}
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}


export function NotFoundIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={187}
            height={187}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 187 187"
        >
            <g
                clipPath="url(#prefix__clip0_640_6478)"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#827252"
                className={fillClassName}
            >
                <path d="M39.687 17.65c-.372 2.343-.383 5.478-.383 10.24v68.02h45.043V27.89c0-3.06-.008-5.005-.201-6.497-.183-1.405-.49-1.96-.727-2.269-.61-.798-1.5-1.502-2.604-2.062-.428-.217-1.224-.536-3.384-.986-2.293-.478-5.343-.954-10.144-1.696-7.47-1.155-12.391-1.909-16.158-2.254-3.676-.337-4.996-.148-5.576-.013-1.836.428-3.418 1.191-4.534 2.19-.353.314-.97 1.06-1.332 3.347zm-19.212-1.165c.494-3.118 1.592-6.225 4.669-8.974 3.35-2.994 8.095-5.285 13.604-6.568C43.808-.236 48.948-.14 53.96.32c4.816.441 10.662 1.345 17.55 2.41l.8.124c4.36.674 8.17 1.263 11.285 1.912 3.33.694 6.537 1.585 9.461 3.068 3.312 1.68 5.98 3.792 7.811 6.186 1.618 2.114 2.238 4.254 2.52 6.42.263 2.026.263 4.454.262 7.233v80.174H26c-2.828 0-4.243 0-5.121-.878-.879-.879-.879-2.293-.879-5.122V27.597c0-4.39 0-8.116.475-11.112z" />
                <path d="M103.851 21.393c-.193 1.492-.201 3.437-.201 6.497v68.02h45.043V27.89c0-4.762-.011-7.897-.383-10.24-.362-2.287-.979-3.033-1.332-3.348-1.116-.998-2.698-1.761-4.534-2.19-.58-.134-1.9-.323-5.576.014-3.767.345-8.688 1.099-16.159 2.254-4.8.742-7.85 1.218-10.143 1.696-2.16.45-2.956.769-3.385.986-1.103.56-1.993 1.264-2.603 2.062-.237.31-.544.864-.727 2.27zm-19.242-.955c.281-2.165.902-4.305 2.52-6.419 1.831-2.394 4.5-4.507 7.81-6.186 2.925-1.483 6.132-2.374 9.461-3.068 3.116-.65 6.926-1.238 11.286-1.912l.8-.124C123.374 1.664 129.22.76 134.036.32c5.012-.46 10.153-.555 15.213.624 5.509 1.283 10.254 3.574 13.604 6.568 3.077 2.75 4.175 5.856 4.669 8.974.475 2.996.475 6.722.475 11.112v74.249c0 2.829 0 4.243-.879 5.122-.879.878-2.293.878-5.121.878h-77.65V27.672c0-2.779 0-5.207.262-7.234zM91.668 139.865c.742-1.038 1.113-1.558 1.627-1.558.515 0 .886.52 1.628 1.558l29.834 41.769c1.626 2.276 2.439 3.414 3.649 3.626a.833.833 0 00.049.008c1.213.192 2.351-.621 4.628-2.247 2.276-1.626 3.414-2.439 3.626-3.648l.008-.05c.192-1.213-.621-2.351-2.247-4.627l-33.412-46.777c-.879-1.232-1.32-1.848-1.966-2.18-.646-.333-1.402-.333-2.916-.333h-5.76c-1.514 0-2.271 0-2.917.333-.646.332-1.086.948-1.966 2.18L52.12 174.696c-1.626 2.276-2.44 3.414-2.247 4.627l.008.05c.212 1.209 1.35 2.022 3.626 3.648 2.277 1.626 3.415 2.439 4.628 2.247a.85.85 0 00.05-.008c1.209-.212 2.022-1.35 3.648-3.626l29.834-41.769z" />
            </g>
            <defs>
                <clipPath id="prefix__clip0_640_6478">
                    <path fill="#fff" d="M0 0h187v186.005H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function ManagerIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={100}
            height={96}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 100 96"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M93.33 49.942c4 2.542 6.67 7.021 6.67 12.126 0 6.512-4.349 12.013-10.275 13.743-.48 11.21-9.669 20.19-20.929 20.19H50.001a1.584 1.584 0 01-1.579-1.589v-2.215c0-3.317 2.683-6.016 5.98-6.016 3.298 0 5.981 2.699 5.981 6.016v.627h8.413c9.34 0 17.008-7.27 17.744-16.477l-.194.012c-.148.01-.297.02-.447.021a4.862 4.862 0 01-3.985 2.092c-2.691 0-4.88-2.202-4.88-4.91V50.55c0-2.707 2.189-4.908 4.88-4.908 1.648 0 3.102.83 3.985 2.092 1.474.014 2.893.254 4.228.688-.641-11.666-6.345-22.57-15.59-29.785-1.596 1.741-3.876 2.79-6.29 2.79-1.297 0-2.549-.29-3.722-.863-8.95-4.366-19.672-4.436-28.676-.18-3.482 1.641-7.487.678-9.94-2.048-9.518 7.15-15.388 18.17-16.035 30.086a14.068 14.068 0 014.227-.688 4.862 4.862 0 013.985-2.092c2.691 0 4.88 2.201 4.88 4.908v23.013c0 2.707-2.189 4.91-4.88 4.91-1.648 0-3.1-.832-3.985-2.093C6.314 76.307 0 69.918 0 62.068c0-5.105 2.67-9.584 6.67-12.126.212-13.597 6.728-26.285 17.59-34.328-.715-1.91-.771-3.983-.075-5.925a8.508 8.508 0 014.403-4.86c13.834-6.534 29.651-6.432 43.39.275a8.51 8.51 0 014.344 4.915c.668 1.938.59 3.997-.137 5.89C86.768 24.026 93.12 36.605 93.33 49.941zM13.207 51.01c-5.62.532-10.048 5.259-10.048 11.06 0 5.789 4.429 10.506 10.048 11.037V51.009zm4.88-2.19c-.95 0-1.722.776-1.722 1.731v23.013a1.73 1.73 0 001.722 1.733 1.73 1.73 0 001.723-1.733V50.55a1.73 1.73 0 00-1.723-1.732zm31.908-34.753c5.47 0 10.938 1.214 15.91 3.64 2.604 1.274 5.944.083 7.191-2.507a5.413 5.413 0 00.244-4.14A5.361 5.361 0 0070.6 7.964C57.72 1.67 42.897 1.58 29.931 7.704a5.364 5.364 0 00-2.775 3.063 5.41 5.41 0 00.19 4.141c.03.064.068.121.105.178.026.042.053.083.077.127.003.003.007.005.009.009l.005.01a.037.037 0 00.004.011c1.363 2.445 4.389 3.474 6.963 2.265 4.857-2.296 10.171-3.442 15.485-3.442zm1.586 78.131v.627h5.645v-.627a2.835 2.835 0 00-2.822-2.84 2.835 2.835 0 00-2.823 2.84zm30.334-16.901a1.73 1.73 0 001.722-1.733V50.55c0-.955-.772-1.732-1.722-1.732a1.73 1.73 0 00-1.723 1.732v23.013a1.73 1.73 0 001.723 1.733zm4.88-24.287v22.097c5.62-.531 10.048-5.248 10.048-11.038 0-5.8-4.429-10.527-10.048-11.06zm-35.214 2.17v17.755c0 .877-.707 1.588-1.579 1.588a1.584 1.584 0 01-1.579-1.588V53.18c0-.877.707-1.589 1.58-1.589.87 0 1.578.712 1.578 1.589zm-17.14 2.572c0-.877.708-1.588 1.58-1.588.871 0 1.579.711 1.579 1.588v12.611c0 .877-.708 1.589-1.58 1.589a1.584 1.584 0 01-1.578-1.589v-12.61zm31.12 12.611v-12.61c0-.878-.707-1.589-1.579-1.589-.871 0-1.578.711-1.578 1.588v12.611c0 .877.707 1.589 1.578 1.589.872 0 1.58-.712 1.58-1.589z"
                fill="#827252"
                className={fillClassName}
            />
        </svg>
    );
}


export function CrossIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={9}
            height={9}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 9 9"
        >
            <path
                d="M1.404 9L0 7.615 3.096 4.5 0 1.404 1.404 0 4.5 3.096 7.596 0 9 1.404 5.904 4.5 9 7.615 7.596 9 4.5 5.904 1.404 9z"
                fill="#A79061"
                className={fillClassName}
            />
        </svg>
    );
}



export function CloseIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M25.925 8.089a1.41 1.41 0 00-1.998 0L17 15.002l-6.928-6.927a1.41 1.41 0 00-1.997 0 1.41 1.41 0 000 1.997L15.003 17l-6.928 6.927a1.41 1.41 0 000 1.997 1.41 1.41 0 001.998 0L17 18.997l6.927 6.927a1.41 1.41 0 001.998 0 1.41 1.41 0 000-1.997L18.997 17l6.928-6.928a1.42 1.42 0 000-1.983z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}


export function ArrowIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 24"
        >
            <path
                d="M7.38 21.01c.49.49 1.28.49 1.77 0l8.31-8.31a.996.996 0 000-1.41L9.15 2.98a1.25 1.25 0 00-1.77 0 1.25 1.25 0 000 1.77L14.62 12l-7.25 7.25c-.48.48-.48 1.28.01 1.76z"
                fill="#E11C23"
                className={fillClassName}
            />
        </svg>
    );
}


export function CatalogIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={21}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 21 21"
        >
            <g clipPath="url(#prefix__clip0_2276_26106)" fill="#fff" className={fillClassName}>
                <rect x={0.5} y={6.5} width={20} height={2} rx={1} />
                <rect x={0.5} y={12.5} width={13} height={2} rx={1} />
            </g>
            <defs>
                <clipPath id="prefix__clip0_2276_26106">
                    <path fill="#fff" className={fillClassName} transform="translate(.5 .5)" d="M0 0h20v20H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function CatalogIconHeader({ mainClassName, fillClassName }) {
    return (
        <svg
            width={21}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 21 21"
        >
            <g clipPath="url(#prefix__clip0_2276_26106)" fill="#fff" className={fillClassName}>
                <rect x={0.5} y={6.5} width={20} height={2} rx={1} />
                <rect x={0.5} y={12.5} width={13} height={2} rx={1} />
            </g>
            <defs>
                <clipPath id="prefix__clip0_2276_26106">
                    <path fill="#fff" className={fillClassName} transform="translate(.5 .5)" d="M0 0h20v20H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}



export function MenuIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M5.667 25.5h22.666a1.42 1.42 0 001.417-1.417 1.42 1.42 0 00-1.417-1.416H5.667a1.42 1.42 0 00-1.417 1.416c0 .78.638 1.417 1.417 1.417zm0-7.083h22.666A1.42 1.42 0 0029.75 17a1.42 1.42 0 00-1.417-1.417H5.667A1.42 1.42 0 004.25 17c0 .78.638 1.417 1.417 1.417zm-1.417-8.5c0 .779.638 1.416 1.417 1.416h22.666a1.42 1.42 0 001.417-1.416A1.42 1.42 0 0028.333 8.5H5.667A1.42 1.42 0 004.25 9.917z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}


export const ClosePopupIcon = ({ mainClassName, strokeClassName }) => (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        className={strokeClassName}
        d="M18.9998 5L5.00004 18.9997"
        stroke="#6F7387"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        className={strokeClassName}
        d="M5.00049 5L19.0002 18.9997"
        stroke="#6F7387"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );